<template>
  <div>
    <section v-if="!isLoading" id="list-puskesmas" class="mt-5">
      <div class="container mt-3">
        <div class="input-group rounded">
          <input
            v-model="search"
            type="search"
            class="form-control rounded"
            placeholder="Search"
            aria-label="Search"
            aria-describedby="search-addon"
          />
          <button @click="searching" class="input-group-text border-0" id="search-addon">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <div class="panel mt-5">
          <div class="d-flex justify-content-evenly">
            <button
              v-if="userRole == 'super_admin'"
              @click="addPuskesmas"
              class="btn btn-outline-primary"
            >
              <i class="bi bi-bookmark-plus-fill text-primary"></i>
              Tambahkan Puskesmas Baru
            </button>
            <button
              class="btn btn-outline-warning"
              v-if="userRole == 'super_admin'"
              @click="vaccineList"
            >
              <i class="bi bi-list-task text-warning"></i>
              Lihat Daftar Vaksin
            </button>
            <button
              class="btn btn-outline-primary"
              v-if="userRole == 'super_admin'"
              data-bs-toggle="modal"
              data-bs-target="#modal-add-admin"
            >
              <i class="bi bi-bookmark-plus-fill text-primary"></i>
              Daftarkan Super Admin
            </button>
          </div>
          <h2 class="text-center mt-5 mb-3">Tabel Puskesmas Terdaftar</h2>
        </div>
        <puskesmas-row />
      </div>
      <Modal />
      <modal-list-admin />
    </section>
    <loading v-if="isLoading" />
  </div>
</template>

<script>
import Loading from "./Loading.vue";
import Modal from "./Modal.vue";
import ModalListAdmin from "./ModalListAdmin.vue";
import PuskesmasRow from "./PuskesmasRow.vue";
export default {
  name: "ListPuskesmas",
  data: function () {
    return {
      userRole: localStorage.role,
      load: this.isLoading,
      search : ''
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.loading;
    },
  },
  components: {
    Modal,
    PuskesmasRow,
    ModalListAdmin,
    Loading,
  },
  methods: {
    addPuskesmas() {
      this.$router.push(`/formaddpuskemas`);
    },
    searching(){
      const searchData = this.search
      this.$store.commit('SEARCHING', searchData)
      this.$store.dispatch("fetchPuskesmas");
      this.search = ''
      this.$store.commit('SEARCHING', '')
    },
    vaccineList() {
      this.$router.push("/vaccines");
    },
  },
  created() {
    this.$store.dispatch("fetchPuskesmas");
  },
};
</script>

<style></style>
